<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Empresas/Instituciones"   />

    <Companies />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue";
import Companies from "@/components/Pages/Admin/Companies/index.vue";

export default defineComponent({
  name: "CompaniesPage",
  components: {
    PageTitle,
    Companies,
  },
});
</script>
